//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mixinMeasure from '../../../mixins/tool/mixinMeasure'
export default {
  name: 'vc-measure-height',
  mixins: [mixinMeasure],
  data () {
    return {
      type: 'heightMeasuring',
      measuring: false,
      startPoint: {},
      polylines: [],
      labels: []
    }
  },
  methods: {
    getDistance (positions) {
      let distance = 0
      for (let i = 0; i < positions.length - 1; i++) {
        const s = Cesium.Cartesian3.distance(positions[i], positions[i + 1])
        distance = distance + s
      }
      return distance
    },
    clear () {
      this.distance = 0
      this.polylines = []
      this.labels = []
      this.measuring = false
    }
  }
}
